module.exports = __webpack_public_path__ + "static/media/icon-fullscreen.5fc76971.svg";